import { Language } from "./Language"

export type SelfUser = {
    userId: string
    organizationLevel: OrganizationLevel | null,
    organizationId: string,
    firstName: string,
    lastName: string,
    language: Language,
    role: string
}

export enum OrganizationLevel {
    CUSTOMER = "CUSTOMER",
    INSTANCE = "INSTANCE",
    SYSTEM = "SYSTEM"
}